import React, { forwardRef } from 'react'

import { B2, Pressable, XStack } from '@zet/design-system'
import ArrowDown from '@zet/design-system/svg/ArrowDown'
import CalenderOutlined from '@zet/design-system/svg/CalenderOutlined'

const DateField = forwardRef(({ value, onClick }, ref) => (
  <Pressable
    className="border-grays-40 mb-3 flex-row items-center justify-between rounded border px-2 py-2"
    ref={ref}
    onPress={onClick}
  >
    <XStack className="items-center">
      <CalenderOutlined />
      <B2 className={value ? 'text-neutral-black' : 'text-grays-50'}>
        {value ? value : 'DD/MM/YYYY'}
      </B2>
    </XStack>
    <ArrowDown />
  </Pressable>
))

export { DateField }
